import { render, staticRenderFns } from "./StageWaiting.vue?vue&type=template&id=54381eb8&scoped=true&lang=pug&"
import script from "./StageWaiting.vue?vue&type=script&lang=js&"
export * from "./StageWaiting.vue?vue&type=script&lang=js&"
import style0 from "./StageWaiting.vue?vue&type=style&index=0&id=54381eb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54381eb8",
  null
  
)

export default component.exports